// frontend/src/components/ContactIcons.jsx
import { FaWhatsapp, FaPhoneAlt, FaRegFileAlt } from "react-icons/fa";
import { DEFAULT_PHONE, telHref, waDigits } from "../utils/constants";
import FloatingActionMenu from "./FloatingActionMenu";
import "./ContactIcons.css";

// Builds the wa.me link with a prefilled message that names the project,
// so whichever project this bundle is deployed for, the WhatsApp chat
// opens already mentioning it (falls back to a generic greeting if the
// project name hasn't loaded yet).
function buildWhatsAppLink(projectName, phoneNumber) {
  const text = projectName
    ? `Hi, I was checking about project ${projectName} in your site. Please share more details.`
    : "Hi, I was checking about this project in your site. Please share more details.";
  return `https://wa.me/${waDigits(phoneNumber)}?text=${encodeURIComponent(text)}`;
}

// Icons come from react-icons (Font Awesome set) instead of raster <img>
// assets — they inherit color via `currentColor`, scale losslessly at any
// size/DPI, and need no network round-trip, so nothing to 404.
export default function ContactIcons({ onCtaClick, projectName, phone }) {
  const callNumber = phone || DEFAULT_PHONE;
  const callHref = telHref(callNumber);
  const waLink = buildWhatsAppLink(projectName, callNumber);

  return (
    <>
      {/* Desktop floating stack: expandable "+" menu (Share / Schedule a
          Visit / Call Us) stacked above the standalone, always-visible
          WhatsApp button. */}
      <div className="contact-float desktop-only" aria-label="Contact options">
        <FloatingActionMenu projectName={projectName} />
        <a
          href={waLink}
          className="contact-float__btn contact-float__btn--wa"
          target="_blank"
          rel="noreferrer"
          aria-label="WhatsApp"
        >
          <FaWhatsapp aria-hidden="true" />
        </a>
      </div>

      {/* Mobile sticky bottom bar — 3-item CTA row: Brochure (left),
          WhatsApp (right), and a raised center "Call" button that dials
          CALL_NUMBER directly via a tel: link. */}
      <div className="mobile-bar mobile-only" role="navigation" aria-label="Contact bar">
        <button
          className="mobile-bar__item"
          onClick={() => onCtaClick("Download Brochure")}
          aria-label="Download brochure"
        >
          <FaRegFileAlt aria-hidden="true" />
          <span>Brochure</span>
        </button>

        {/* Reserves the gap the raised center button sits over. */}
        <div className="mobile-bar__center-spacer" aria-hidden="true" />

        <a
          href={waLink}
          className="mobile-bar__item"
          target="_blank"
          rel="noreferrer"
          aria-label="Chat on WhatsApp"
        >
          <FaWhatsapp aria-hidden="true" />
          <span>WhatsApp</span>
        </a>

        <a
          href={callHref}
          className="mobile-bar__center"
          onClick={() => onCtaClick("Instant Call")}
          aria-label={`Call us at ${callNumber}`}
        >
          <FaPhoneAlt aria-hidden="true" />
          <span>Call</span>
        </a>
      </div>
    </>
  );
}